export const SHOWOFF_ELEMENTS = {
  MENU_BUTTON: 'menu_button',
  DASHBOARD_BUTTON: 'Dashboard',
  MY_ACCOUNT_CARD: 'account',
  RECENTLY_PLAYED_CARD: 'recently_played_games',
  GAME_HELP_BUTTON: 'Game Help',
  TIMERS: 'timers',
  EXIT_BUTTON: 'exit_button',
} as const;

export const FEATURE_PROGRESS = {
  FULL: 'full',
  NOTICED: 'noticed',
} as const;

export const FOCUS_TYPE = {
  OVERLAY: 'overlay',
  BOX: 'box',
  NOTHING: 'nothing',
} as const;

export const DISMISS_TYPE = {
  TIMEOUT: 'timeout',
  ACTION: 'action',
} as const;

export const ACTION_TYPE = { SWIPE_TO: 'swipe_to' } as const;

export type ShowoffElementType =
  (typeof SHOWOFF_ELEMENTS)[keyof typeof SHOWOFF_ELEMENTS];
export type FeatureProgressType =
  (typeof FEATURE_PROGRESS)[keyof typeof FEATURE_PROGRESS];
export type FocusType = (typeof FOCUS_TYPE)[keyof typeof FOCUS_TYPE];
export type DismissType = (typeof DISMISS_TYPE)[keyof typeof DISMISS_TYPE];
export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];

export interface StepType {
  attr: ShowoffElementType;
  focusType: FocusType;
  bypassCondition?: (elem: HTMLElement) => boolean;
  dismissType?: DismissType;
  order?: number;
}

export type CurrentSelectedType = Omit<StepType, 'attr'> & {
  element: HTMLElement;
};

export interface ShowoffItemInitial {
  feature?: boolean;
  step?: boolean;
  focusType?: FocusType;
  bypassCondition?: (elem: HTMLElement) => boolean;
  attributeName: ShowoffElementType;
  children?: ShowoffStructure;
  order?: number;
  dismissType?: DismissType;
  triggerAction?: ActionType;
}

export type ShowoffStructure = {
  [key in keyof typeof SHOWOFF_ELEMENTS]?: ShowoffItemInitial;
};

export interface ShowoffItemFormatted {
  steps: StepType[];
  notice?: boolean;
  show?: boolean;
  name: ShowoffElementType;
  order?: number;
  dismissType?: DismissType;
}

export interface ShowoffContext {
  name: ShowoffElementType | null;
  feature: ShowoffItemFormatted | null;
  currentStep: (CurrentSelectedType & { name: ShowoffElementType }) | null;
}

export const POSSIBLE_POSITIONS = ['top', 'right', 'bottom', 'left'] as const;

export type PositionType = (typeof POSSIBLE_POSITIONS)[number];

export interface DashboardItem {
  type: ShowoffElementType;
  show: boolean;
}
